<template>
    <!-- MODALE de remplacement d'un anciens bookmark par un nouveau bookmark -->
    <b-modal centered no-close-on-backdrop no-close-on-esc body-class="pb-2" :visible="askShow">
        <template #modal-header>
            <b-col cols="11"><h5 class="modal-title">{{ $t('FeatureBookmarkMaxReach') }}</h5></b-col>
            <b-col cols="1" class="py-2 px-0">
                <b-icon role="button" icon="x-lg" font-scale="1.5" @click="cancel()" v-b-tooltip.hover /><!-- Fermer -->
            </b-col>
        </template>
        <b-card :header="$t('AskChooseBookmarkToReplace')" no-body>
            <b-card-body class="pt-0 pb-2">
                <div class="py-2 border-top" >
                    <b-container>
                        <b-row :id="'bookmark-modal-item-' + bookmark.Feature.replaceAll(' / ','')" v-for="bookmark in Bookmarks" v-bind:key="bookmark.Feature" class="bg-white rounded mt-2 py-2" role="button" 
                            @click="selectDeleteListItem($event,bookmark)">
                            <!-- Icône du level 1-->
                            <b-col cols="1" class="px-0 pr-0 pl-2 " >
                                <div :class="'border border-'+ Variant +' d-flex align-items-center justify-content-center p-0 img-circle'">
                                    <font-awesome-icon :icon="getRootIconFromBookmark(bookmark)" size="lg" :class="Variant +'-light text-'+ Variant" />
                                </div>
                            </b-col>
                            <!-- Affichage du path avec le bon formatage ( délimiteur '>', couleurs, text-truncate, ...)-->
                            <b-col cols="10" :class="'pr-1 d-flex flex-row align-items-center text-truncate text-decoration-none text-'+Variant" >
                                <div v-for="format in getTranslateDescriptionPath(bookmark,'>')" 
                                    :class="'pl-1 ' + (format.IsLast ? ' ' : 'text-gray-dark ')+ ((!format.IsLast && !format.IsFirst && !format.IsDelimiter) ? 'text-truncate ': ' ')" > {{ format.TranslateContent }}</div>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
            </b-card-body>
        </b-card>
        <template #modal-footer>
            <b-button :variant="'outline-'+Variant" pill @click="cancel()">{{ $t('Cancel') }}</b-button><!-- Annule -->
            <b-button :variant="Variant" :disabled="disableDeleteButton" pill @click="validate()">{{ $t('Delete') }}</b-button><!-- Valide -->
        </template>
    </b-modal>
</template>

<script lang="ts">
    /** Importe les d�corateurs pour utiliser @Component et @Prop */
    import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
    import { mixins } from 'vue-class-component';

    /** Types custom import� depuis /types */
    import Bookmark from '@/types/Bookmark';
    
    /** Fichiers de traductions */
    import locales from "./locales/BookmarksReplace.json";
    import featuresLocales from "@/locales/features.json";
    
    /** Classe mère pour faciliter la gestion des tailles d'écrans */
    import { ScreenUtils } from '@/components/commons/Utils';
    /** Classe mère pour faciliter le formatage des paths de marque-pages */
    import { BookmarkUtils } from '../BookmarkUtils';

    /** Composant d'affichage du menu listant les fonctions */
    @Component({
        i18n: { messages : locales }
    })
    export default class BookmarksReplace extends mixins(ScreenUtils, BookmarkUtils) {
        /** Variant de thème utilisé par les pères */
        @Prop({ default: "primary" })
        public Variant!: string;

        /** Liste des bookmarks à charger sous forme de menu en provenance du père */
        @Prop({ default: [] })
        public Bookmarks!: Bookmark[];

        /** Bookmark à ajouter dans la base, lors de la validation */
        @Prop({ default: { Id: -1 , Feature : ""} })
        public BookmarkToAdd! : Bookmark;

        /** Propriété responsable de l'affichage de la modal */
        @PropSync("AskShow",{ default : () => false })
        public askShow!: boolean; 

        /** Bookmarks à retirer de la base, lors de la validation */
        private bookmarksToDelete: { [key: string]: Bookmark } = {};
        /** Paramètre d'affichage du bouton supprimer (activé / désactivé) */
        private disableDeleteButton: boolean = true;

        /**
         * Selectionne un item de la liste de suppression dans la modal
         * @param bookmark "bookmark" à ajouter dans la liste de suppression
         */
        private async selectDeleteListItem(event: MouseEvent, bookmark: Bookmark) {
            let target: HTMLElement = event.target as HTMLElement;
            let htmlSource: HTMLElement = target.closest('#bookmark-modal-item-' + bookmark.Feature.replaceAll(' / ',''));

            if(bookmark.Feature in this.bookmarksToDelete) {
                delete this.bookmarksToDelete[bookmark.Feature];
                htmlSource.classList.remove('bg-' + this.Variant + '-bg-subtle');
                htmlSource.classList.add('bg-white');
            }
            else {
                this.bookmarksToDelete[bookmark.Feature] = bookmark;
                htmlSource.classList.add('bg-' + this.Variant + '-bg-subtle');
                htmlSource.classList.remove('bg-white');
            }

            this.disableDeleteButton = !(Object.keys(this.bookmarksToDelete).length > 0);
        }

        /** Reset les propriétés pour une nouvelle utilisation */
        private reset() {
            this.bookmarksToDelete = {};
            this.disableDeleteButton = true;
            this.askShow = false;
        }

        /** Valide la procédure de remplacement et met à jour la liste des "bookmarks" en conséquence. */
        private validate() {
            this.$emit('validateEvent', [this.BookmarkToAdd], Object.values(this.bookmarksToDelete));
            let nbDelete = Object.keys(this.bookmarksToDelete).length;
            this.reset();
            this.$bvToast.toast(nbDelete + ' ' + this.$tc('ValidateDelete', nbDelete).toString(), {
                title: this.$tc('Validate', nbDelete).toString(), // "Enregistrement",
                autoHideDelay: 3000,
                variant: "success",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        }

        /** Annule la procédure de remplacement d'un "bookmark" */
        private cancel() {
            this.reset();
        }

        /** Initialisation de la vue et du module de traduction */
        async created() {
            /** Chargement des traductions des features */
            this.$root.$i18n.mergeLocaleMessage(this.$i18n.locale, featuresLocales[this.$i18n.locale]);
        }
    };
</script>

<style scoped>
</style>